import React, { Component } from 'react';
import { withApollo } from '@apollo/react-hoc';
import { Button } from 'antd';
import { gql } from '@apollo/client';
import styles from './styles.scss';

const SET_ACTIVE_PRODUCT = gql`
  mutation SetActiveProduct($input: SetActiveProductInput!) {
    setActiveProduct(input: $input) {
      user {
        uuid
        activeProductSlug
      }
    }
  }
`;

class SetActiveProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasClicked: false,
    };
  }

  handleClick = async () => {
    const { client, product } = this.props;
    const { slug } = product;

    client.mutate({
      mutation: SET_ACTIVE_PRODUCT,
      variables: {
        input: {
          slug,
        },
      },
    });

    this.setState({
      hasClicked: true,
    });
  };

  renderLayout = ({ hasClicked }) => {
    const { product } = this.props;
    const { slug: productSlug } = product;
    const buttonText = hasClicked ? 'Current exam set' : 'Yes, set it';
    const disabled = hasClicked;

    return (
      <div className={styles.layout}>
        <div className={styles.ctaText}>
          Would you like to set this as your current exam?
        </div>
        <Button
          data-aaa="setActive"
          data-product-slug={productSlug}
          className={styles.green}
          onClick={this.handleClick}
          disabled={disabled}
        >
          {buttonText}
        </Button>
      </div>
    );
  };

  render() {
    const { currentUser, product } = this.props;
    const { hasClicked } = this.state;
    const { slug } = product;

    if (!hasClicked && currentUser.activeProductSlug === slug) {
      return null;
    }

    return this.renderLayout({ hasClicked });
  }
}

export default withApollo(SetActiveProduct);
